import { mapGetters } from "vuex";
import { MODULES, PAGE_KEYS } from "@/config";

export const pageInformationMixin = {
  computed: {
    ...mapGetters(MODULES.APP, {
      pageField: "getPageField",
    }),
    pageHeaderArch() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.headerArch);
    },
    pageTheme() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.theme);
    },
    pageTitle() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.title);
    },
    pageModule() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.moduleName);
    },
    pageId() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.id);
    },
    pageType() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.type);
    },
    pageData() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.data);
    },
    componentType() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.componentType);
    },
    defaultProgression() {
      const { pageField } = this;

      const dataField = pageField(PAGE_KEYS.data);

      return dataField[PAGE_KEYS.defaultProgression];
    },
    targetField() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.targetField);
    },
    targetState() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.targetState);
    },
    targetPages() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.targetPages);
    },
    hasBackwardsNavEnabled() {
      const { pageField } = this;

      return pageField(PAGE_KEYS.backwardsNavEnabled);
    },
  },
};
